import { render, staticRenderFns } from "./mediaDimension.vue?vue&type=template&id=06e46a9b&scoped=true&"
import script from "./mediaDimension.vue?vue&type=script&lang=js&"
export * from "./mediaDimension.vue?vue&type=script&lang=js&"
import style0 from "./mediaDimension.vue?vue&type=style&index=0&id=06e46a9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e46a9b",
  null
  
)

export default component.exports